import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import { schedulePropTypes, scheduleInsightsPropTypes } from 'constants/propTypes';

import { Card, CardSection, CardTitle } from 'components/Card';
import { PillGraphLegend } from 'components/PillGraph';
import Message from 'components/Message';

import { deriveReservationsGraphLegendItems } from '../Insights.helpers';

import HistoricalUtilizationTable from './HistoricalUtilizationTable';

import './HistoricalUtilization.scss';

const messages = defineMessages({
  title: {
    id: 'yield-management.insights.historical-utilization.title',
    defaultMessage: 'Historical Utilization',
  },
  subtitle: {
    id: 'yield-management.insights.historical-utilization.subtitle',
    defaultMessage: 'last {weeksCount, plural, one {week} other {# weeks}}',
  },
  summary: {
    id: 'yield-management.insights.historical-utilization.summary',
    defaultMessage:
      'Take a look at the performance of {className} at {startDateTime, date, time} for the past {weeksCount, plural, one {week} other {# weeks}}.',
  },
});

const HistoricalUtilization = ({ schedule, insights, canViewRates, currencyCode, noDirectFillData }) => {
  const { scheduleName, startDateTime } = schedule;
  const { history = [] } = insights;

  if (!history.length) {
    return null;
  }

  const graphLegendItems = deriveReservationsGraphLegendItems(noDirectFillData);

  return (
    <Card className="historical-utilization" flush>
      <CardSection className="historical-utilization__header p-r border-b">
        <Message as={CardTitle} message={messages.title} />
        <Message className="text--light text--sm" message={messages.subtitle} values={{ weeksCount: history.length }} />
      </CardSection>
      <CardSection>
        <Message
          as="p"
          className="historical-utilization__summary mb-h"
          message={messages.summary}
          values={{
            className: scheduleName,
            startDateTime,
            weeksCount: history.length,
          }}
        />
        <PillGraphLegend items={graphLegendItems} />
      </CardSection>
      <HistoricalUtilizationTable
        utilization={history}
        currencyCode={currencyCode}
        noDirectFillData={noDirectFillData}
        canViewRates={canViewRates}
      />
    </Card>
  );
};

HistoricalUtilization.propTypes = {
  canViewRates: PropTypes.bool,
  currencyCode: PropTypes.string,
  insights: PropTypes.shape(scheduleInsightsPropTypes),
  noDirectFillData: PropTypes.bool,
  schedule: PropTypes.shape(schedulePropTypes),
};

export default HistoricalUtilization;
